import { get } from "@insite/client-framework/Services/ApiService";

export interface RoleBaseModel {
    pageId: string,
    nodeId: string,
    userRole: string
}
export interface ApiResultModel {
    contentResults: RoleBaseModel[];
}
export interface ApiResultAllRolesModel {
    map(arg0: (o: string) => { value: string; displayName: string; }): import("@insite/client-framework/Types/FieldDefinition").Option<string>[] | PromiseLike<import("@insite/client-framework/Types/FieldDefinition").Option<string>[]>;
    results: string[];
}

const url = "/api/v1/rolebasedwebsitepages/pagerolemapping";
const userroles = "/api/v1/rolebasedwebsitepages/userroles";

export async function getRoleBasePages() {
    const response = await get<ApiResultModel>(`${url}`);
    return response;
}


export async function fetchAllRoles() {
    const response = await get<ApiResultAllRolesModel>(`${userroles}`);
    return response;
}